// src/components/HeroSlider.jsx (Dynamic API Version)
import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

// Import fallback images
import slide1 from "../assets/images/sliders/5.webp";
import slide2 from "../assets/images/sliders/6.webp";
import aboutUs from "../assets/images/banners/26.webp";

const HeroSlider = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  // Get API configuration
  const api_url =
    localStorage.getItem("api_url") || "http://localhost/inscape_backend/api/";

  // Default static slides (fallback)
  const defaultSlides = [
    {
      id: 1,
      banner_image_url: slide1,
      banner_heading_txt:
        "	We Build Trust And Maintaining A Long Lasting Relations!",
      banner_short_txt:
        "Our specialist team of consultants understands the importance of maintaining a long lasting business relationships with clients to deliver investment solutions for a long term success.",
    },
    {
      id: 2,
      banner_image_url: slide2,
      banner_heading_txt:
        "Global Consulting Firm Experienced In Financial Business!",
      banner_short_txt:
        "Our specialist team of consultants understands the importance of maintaining a long lasting business relationships with clients to deliver investment solutions for a long term success.",
    },
  ];

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("company_id", "1");
      formData.append("employee_id", "1");
      formData.append("type", "1"); // Type 1 for show all active banners

      const response = await fetch(`${api_url}banner.php`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status === "1" && data.result && data.result.length > 0) {
        setBanners(data.result);
      } else {
        // Use default slides if no banners found
        setBanners(defaultSlides);
      }
    } catch (err) {
      console.error("Error fetching banners:", err);
      // Use default slides on error
      setBanners(defaultSlides);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Apply background image logic after banners are loaded
    if (!loading && banners.length > 0) {
      const applyBackgroundImages = () => {
        document.querySelectorAll(".bg-img")?.forEach((el) => {
          const img = el.querySelector("img");
          if (img) {
            const parent = el.parentElement;
            if (parent) {
              parent.style.backgroundImage = `url(${img.src})`;
              parent.style.backgroundSize = "cover";
              parent.style.backgroundPosition = "center";
              parent.classList.add("bg-img");
              if (el.classList.contains("background-size-auto")) {
                parent.classList.add("background-size-auto");
              }
            }
            el.remove();
          }
        });
      };

      // Small delay to ensure images are loaded
      const timer = setTimeout(applyBackgroundImages, 100);

      return () => clearTimeout(timer);
    }
  }, [loading, banners]);

  // Use API banners if available, otherwise use default
  const displaySlides = banners.length > 0 ? banners : defaultSlides;

  return (
    <>
      <section className="slider slider-arrows-bottom-right py-0">
        <Swiper
          className="swiper swiper-controls-light p-0 m-0"
          modules={[Navigation, Autoplay]}
          slidesPerView={1}
          spaceBetween={0}
          autoplay={{
            delay: 10000,
            disableOnInteraction: false,
          }}
          loop={true}
          speed={1000}
          navigation={{
            nextEl: ".slider-next",
            prevEl: ".slider-prev",
          }}
        >
          <div className="swiper-wrapper">
            {displaySlides.map((slide, index) => (
              <SwiperSlide
                key={slide.banner_id || slide.id || index}
                className="swiper-slide slide-item bg-overlay align-v-h"
              >
                <div className="bg-img">
                  <img
                    src={slide.banner_image_url}
                    alt={slide.banner_heading_txt || "slide img"}
                    onError={(e) => {
                      // Fallback to default image if API image fails
                      e.target.src = index === 0 ? slide1 : slide2;
                    }}
                  />
                </div>
                <div className="container">
                  <div className="row align-items-center">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7">
                      <h2 className="hero-title">
                        {slide.banner_heading_txt ||
                          "Empowering Your Growth with Integrity and Insight"}
                      </h2>
                      <div className="hero-data d-flex flex-wrap gap-40">
                        <svg
                          className="animated-arrow color-white"
                          xmlns="http://www.w3.org/2000/svg"
                          width={68}
                          height={68}
                          viewBox="0 0 101.7 101.7"
                        >
                          <g fill="none" stroke="currentColor" strokeWidth={6}>
                            <path d="m.7 101 100-100" strokeLinejoin="round" />
                            <path
                              d="M.7 1h100"
                              strokeWidth={9}
                              strokeLinejoin="round"
                            />
                            <path
                              d="M100.7 1v100"
                              strokeWidth={9}
                              strokeLinejoin="round"
                            />
                          </g>
                        </svg>
                        <div className="flex-1">
                          <p className="hero-desc">
                            {slide.banner_short_txt ||
                              "We support Australian accounting and tax practices with reliable, compliant, and secure outsourcing solutions - helping you improve efficiency, turnaround time, and profitability."}
                          </p>
                          <div className="d-flex flex-wrap align-items-center gap-30">
                            <Link
                              to="/services"
                              className="btn btn-primary same-hover arrow-hover-flip-up"
                            >
                              <span>our services</span>
                              <svg
                                className="arrow-flip"
                                enableBackground="new 0 0 64 64"
                                viewBox="0 0 64 64"
                                width={12}
                                height={12}
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g className="arrow-flip-path-1">
                                  <path
                                    d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                                    fill="currentColor"
                                  />
                                </g>
                                <g className="arrow-flip-path-2">
                                  <path
                                    d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                                    fill="currentColor"
                                  />
                                </g>
                              </svg>
                            </Link>
                            <Link to="/about-us" className="btn btn-white">
                              About Inscape
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /.col-xl-7 */}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </div>
          {/* Navigation Buttons */}
          <div className="slider-next swiper-button-prev-2 icon-arrow-left"></div>
          <div className="slider-prev swiper-button-next-2 icon-arrow-right"></div>
        </Swiper>
      </section>

      <section className="banner-layout13 py-0">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7">
            <div className="banner-text bg-gray">
              <div className="banner-alert d-flex align-items-center">
                <div className="alert-icon">
                  <i className="icon-alert" />
                </div>
                <h3 className="alert-title mb-0">
                  Impartial Accounting Consulting & Taxation Services to Empower
                  Your Growth!
                </h3>
              </div>
              <div className="banner-text-inner">
                <div className="heading-layout2">
                  <h3 className="heading-title mb-30">
                    Experienced in identifying, assessing, and solving all
                    business challenges!
                  </h3>
                </div>
                <div className="cta-wrapper d-flex align-items-start flex-wrap gap-50">
                  <div className="cta" style={{ padding: "20px 10px" }}>
                    <div className="cta-icon" style={{ width: "160px" }}>
                      <i className="icon-employee-of-the-month" />
                    </div>
                    <h3
                      className="cta-title mb-0"
                      style={{ fontSize: "15px", textAlign: "center" }}
                    >
                      18 years of experience in Accounting & Taxation
                    </h3>
                  </div>
                  <div className="heading-layout2 flex-1">
                    <p
                      className="heading-desc fw-bold color-secondary mb-10"
                      style={{ fontSize: "15px" }}
                    >
                      With over 18 years of experience in accounting, including
                      12 years of specialised expertise in Australian accounting
                      and valuable Big 4 experience, Inscape brings a strong
                      foundation of technical knowledge and hands-on industry
                      expertise to every engagement.
                    </p>
                    <p className="heading-desc mb-20">
                      Our team has extensive exposure to Australian accounting
                      standards, taxation laws, compliance requirements, and
                      practice workflows, enabling us to support accounting
                      firms and businesses with confidence and precision.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-5 video-column">
            <div className="video-banner">
              <img src={aboutUs} alt="video img" className="w-100" />
              <Link
                className="video-btn video-btn-sm top-right-btn glightbox"
                href="https://www.youtube.com/watch?v=pAeEAfPglWI&ab_channel=EnvatoTuts%2B"
              >
                <div className="video-player">
                  <i className="icon-play" />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSlider;
